import type { FunctionComponent } from 'react';

import { Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import ErrorButton from 'components/buttons/ErrorButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
import Panel from 'components/containers/Panel';
import ParagraphText from 'components/text/ParagraphText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const FormDiscardConfirmationPanel: FunctionComponent<Props> = ({
    onBack,
    onDiscard,
    testId = TEST_ID
}) => {
    const { BACK_BUTTON_TEXT, CONFIRMATION_TEXT, DISCARD_BUTTON_TEXT } = useTranslation();

    return (
        <Panel className={styles.formDiscardConfirmationPanel} testId={testId}>
            <Wrapper className={styles.wrapper}>
                <ParagraphText text={CONFIRMATION_TEXT} />
            </Wrapper>

            <Grid className={styles.grid}>
                <PrimaryButton
                    className={styles.primaryButton}
                    onClick={onBack}
                    text={BACK_BUTTON_TEXT}
                />

                <ErrorButton
                    className={styles.errorButton}
                    onClick={onDiscard}
                    text={DISCARD_BUTTON_TEXT}
                />
            </Grid>
        </Panel>
    );
};

export default FormDiscardConfirmationPanel;
